import gql from "graphql-tag";

export const UPSERT_TASK_EVENT_MUTATION = gql`
  mutation upsertTaskEvent($taskEventId: ID!, $data: TaskEventInput!) {
    upsertTaskEvent(taskEventId: $taskEventId, data: $data) {
      error
      updated
    }
  }
`;

export const UPSERT_MULTI_TASK_EVENT_MUTATION = gql`
  mutation upsertMultiTaskEvent($taskEventIds: [ID]!, $data: TaskEventInput!) {
    upsertMultiTaskEvent(taskEventIds: $taskEventIds, data: $data) {
      error
      updated
    }
  }
`;

export const CREATE_TASK_COMMENT_MUTATION = gql`
  mutation createdTaskEventComment($taskId: ID!, $text: String!) {
    createdTaskEventComment(taskId: $taskId, text: $text) {
      error
      success
    }
  }
`;

export const DELETE_TASK_COMMENT_MUTATION = gql`
  mutation deleteTaskComment($id: ID!) {
    deleteTaskComment(id: $id) {
      error
      success
    }
  }
`;

export const CREATE_TASK_EVENT_MUTATION = gql`
  mutation createTaskEvent($data: TaskEventInput!) {
    createTaskEvent(data: $data) {
      created
      error
    }
  }
`;

export const DELETE_TASK_ATTACHMENT_MUTATION = gql`
  mutation deleteTaskAttachment($id: ID!) {
    deleteTaskAttachment(id: $id) {
      error
      success
    }
  }
`;
